<template>
  <v-container>
    <v-row>
      <v-col cols="10">
        <div class="d-flex flex-column align-center mt-4 text-center">
          <h2>Statistik</h2>
        </div>
      </v-col>
      <v-col cols="2">
        <div class="d-flex flex-column align-center mt-4 text-center">
          <v-btn color="secondary"  @click="generateCSV">CSV Export</v-btn>
        </div>
       
      </v-col>
    </v-row>
    
    <v-row>
      <v-col>
        <v-autocomplete
            label="Schichten auswählen"
            :items="employCycles"
            :item-title="(item) => `${item.cycleid}`"
            item-value="cycleid"
            v-model="selectedEmployCycles"
            multiple
            chips
            clearable
            return-object
        />
      </v-col>
      <v-col>
        <v-autocomplete
            label="Zeitraum auswählen"
            :items="periods"
            v-model="selectedPeriods"
            multiple
            chips
            clearable
            return-object
        />
      </v-col>
    </v-row>
    <v-container v-if="selectedPeriods">
      <div class="d-flex flex-column mt-4">
        <h3>WDP Abgegeben Status</h3>
      </div>

      <span>Plan eingegeben</span>
      <v-progress-linear
          class="bg-white"
          v-model="wdpInput"
          :max="wdpInputMax"
          height="25"
          color="#00D978"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{wdpInput}}/{{wdpInputMax}} ({{ wdpInput > 0 ? Math.ceil((wdpInput / wdpInputMax) * 100) : 0 }}%) </strong></div>
  <!--
      <span>Plan abgeschickt</span>
      <v-progress-linear
          class="bg-white"
          v-model="wdpSend"
          :max="wdpSendMax"
          height="25"
          color="#00A45B"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{wdpSend}}/{{wdpSendMax}} ({{ wdpSend > 0 ? Math.ceil((wdpSend / wdpSendMax) * 100) : 0 }}%) </strong></div>
  -->
      <span>WDP geöffnet Gesamtansicht nicht auf den Zeitraum bezogen.</span>
      <v-progress-linear
          class="bg-white"
          v-model="wdpOpened"
          :max="wdpOpenedMax"
          height="25"
          color="#00693A"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{wdpOpened}}/{{wdpOpenedMax}} ({{ wdpOpened > 0 ? Math.ceil((wdpOpened / wdpOpenedMax) * 100) : 0 }}%) </strong></div>

      <div class="d-flex flex-column mt-4">
        <h3>WDP Erfüllung</h3>
      </div>

      <span>Freie Tage</span>
      <v-progress-linear
        v-if="freeDaysMax > 0"
          class="bg-white"
          v-model="freeDays"
          :max="freeDaysMax"
          height="25"
          color="green"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{freeDays}}/{{freeDaysMax}} ({{ freeDays > 0 ? Math.ceil((freeDays / freeDaysMax) * 100) : 0 }}%) </strong></div>

      <span>Frühschicht</span>
      <v-progress-linear
        v-if="earlyDaysMax > 0"
          class="bg-white"
          v-model="earlyDays"
          :max="earlyDaysMax"
          height="25"
          color="orange"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{earlyDays}}/{{earlyDaysMax}} ({{ earlyDays > 0 ? Math.ceil((earlyDays / earlyDaysMax) * 100) : 0 }}%) </strong></div>

      <span>Mittelschicht</span>
      <v-progress-linear
        v-if="middleDaysMax > 0"
          class="bg-white"
          v-model="middleDays"
          :max="middleDaysMax"
          height="25"
          color="pink"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{middleDays}}/{{middleDaysMax}} ({{ middleDays > 0 ? Math.ceil((middleDays / middleDaysMax) * 100) : 0 }}%) </strong></div>

      <span>Spätschicht</span>
      <v-progress-linear
        v-if="lateDaysMax > 0"
          class="bg-white"
          v-model="lateDays"
          :max="lateDaysMax"
          height="25"
          color="purple"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{lateDays}}/{{lateDaysMax}} ({{ lateDays > 0 ? Math.ceil((lateDays / lateDaysMax) * 100) : 0 }}%) </strong></div>

      <span>Geteilter Dienst</span>
      <v-progress-linear
        v-if="sharedDaysMax > 0"
          class="bg-white"
          v-model="sharedDays"
          :max="sharedDaysMax"
          height="25"
          color="teal"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{sharedDays}}/{{sharedDaysMax}} ({{ sharedDays > 0 ? Math.ceil((sharedDays / sharedDaysMax) * 100) : 0 }}%) </strong></div>

      <span>Nachtexpress</span>
      <v-progress-linear
        v-if="nightExpressDaysMax > 0"
          class="bg-white"
          v-model="nightExpressDays"
          :max="nightExpressDaysMax"
          height="25"
          color="blue"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{nightExpressDays}}/{{nightExpressDaysMax}} ({{ nightExpressDays > 0 ? Math.ceil((nightExpressDays / nightExpressDaysMax) * 100) : 0 }}%) </strong></div>

      <span>Gesamt</span>
      <v-progress-linear
        v-if="totalMax > 0"
          class="bg-white"
          v-model="total"
          :max="totalMax"
          height="25"
          color="gray"
      >
      </v-progress-linear>
      <div><strong class="mb-2">{{total}}/{{totalMax}} ({{ total > 0 ? Math.ceil((total / totalMax) * 100) : 0 }}%) </strong></div>
    </v-container>
  </v-container>
</template>

<script setup lang="ts">
import {computed, ref, watch, nextTick} from "vue"
import {useCollection} from "vuefire"
import {collection, collectionGroup, query, where, getDocs} from "firebase/firestore"
import {db} from "@/main"
import { convertUtcToGermanLocal, sumTimeStrings, getNormalizedService } from "@/hooks/utils"
import { group } from "console"
//import { nextTick } from "process"

const wdp = ref(44);

const employ = useCollection(collection(db, 'employ'));
const periods = useCollection(query(
    collection(db, "wishPeriods"),
    where("hidden", "==", false),
))
const userData = useCollection(collection(db, 'userData'))
/*
const employCycles = computed(() => {
  return new Set(employ.value.map(element => element.cycleid));
})*/

const employCycles = computed(() => {
  const cycleMap = new Map()
  employ.value.forEach(({ cycleid, machineid, jobid }) => {
    if (!cycleMap.has(cycleid)) {
      cycleMap.set(cycleid, { cycleid, machineid, jobids: new Set() })
    }
    cycleMap.get(cycleid).jobids.add(jobid) // Set verhindert doppelte jobids
  });

  // Konvertiere Sets zurück in Arrays, weil Vue keine Sets in Templates rendert
  return  Array.from(cycleMap.values()).map(entry => ({
    ...entry,
    jobids: Array.from(entry.jobids)
  }))
})


const wishData = useCollection(collection(db, 'wishData'));

const selectedEmployCycles = ref([]);
const selectedPeriods = ref([]);

const wdpInput = computed(() => {
  var returnValue = 0;
  
  employCycles.value.forEach(cycle => {
    employ.value.filter(element => element.cycleid === cycle.cycleid).forEach(element => {
      userData.value.filter(entry => entry.email === element.adacount).forEach(entry => {
        selectedPeriods.value.forEach(period => {
          if(wishData.value.some(wish => wish.wishPeriodId === period.id && wish.userId === entry.sub)){
            returnValue++;
          }
        });
      });
    });
  });
  
  return returnValue;
});
const wdpInputMax = computed(() => {
  return employ.value.filter(element =>
    selectedEmployCycles.value.map(cycle => cycle.cycleid).includes(element.cycleid)
  ).length * selectedPeriods.value.length;
});
/*
const wdpSend = computed(() => {
  var returnValue = 0;

  employCycles.value.forEach(cycle => {
    employ.value.filter(element => element.cycleid === cycle).forEach(element => {
      userData.value.filter(entry => entry.email === element.adacount).forEach(entry => {
        selectedPeriods.value.forEach(period => {
          if(wishData.value.some(wish => wish.wishPeriodId === period.id && wish.userId === entry.sub && wish.finished)){
            returnValue++;
          }
        });
      });
    });
  });

  return returnValue;
});
const wdpSendMax = computed(() => {
  return employ.value.filter(element =>
      selectedEmployCycles.value.includes(element.cycleid)
  ).length * selectedPeriods.value.length;
});
*/
const wdpOpened = computed(() => {
  var returnValue = 0;
  
  selectedEmployCycles.value.forEach(cycle => {
    employ.value.filter(element => element.cycleid === cycle.cycleid).forEach(element => {
      if(userData.value.some(entry => entry.email === element.adacount)){
        returnValue++;
      }
    });
  });
  
  return returnValue;
});
const wdpOpenedMax = computed(() => {
  return employ.value.filter(element =>
      selectedEmployCycles.value.map(cycle => cycle.cycleid).includes(element.cycleid)
  ).length;
});

const freeDays = ref(0)
const freeDaysMax = ref(0)
const earlyDays = ref(0)
const earlyDaysMax = ref(0)
const middleDays = ref(0)
const middleDaysMax = ref(0)
const lateDays = ref(0)
const lateDaysMax = ref(0)
const sharedDays = ref(0)
const sharedDaysMax = ref(0)
const nightExpressDays = ref(0)
const nightExpressDaysMax = ref(0)
const vacationDays = ref(0)
const vacationDaysMax = ref(0)
const total = ref(0)
const totalMax = ref(0) 

watch(() => [selectedEmployCycles, selectedPeriods], async ([newselectedEmployCycles, newselectedPeriods]) => {
  console.log("STATISTIK", newselectedEmployCycles.value, newselectedPeriods.value)
  
  freeDays.value = 0
  freeDaysMax.value = 0
  earlyDays.value = 0
  earlyDaysMax.value = 0
  middleDays.value = 0
  middleDaysMax.value = 0
  lateDays.value = 0
  lateDaysMax.value = 0
  sharedDays.value = 0
  sharedDaysMax.value = 0
  nightExpressDays.value = 0
  nightExpressDaysMax.value = 0
  vacationDays.value = 0
  vacationDaysMax.value = 0
  total.value = 0
  totalMax.value = 0 
  await nextTick()
  console.log("Length", newselectedEmployCycles.value.length, newselectedPeriods.value.length)
  if (newselectedEmployCycles.value.length === 0 || newselectedPeriods.value.length === 0) return
  const cycleIds = newselectedEmployCycles.value.map(cycle => cycle.cycleid)
  
  console.log("Get Employe", cycleIds)
  const usersRef = collection(db, "employ");
  const usersQuery = query(usersRef, where("cycleid", "in", cycleIds));
  const usersSnapshot = await getDocs(usersQuery);

  // User-IDs sammeln
  const userIds: string[] = []
  usersSnapshot.forEach((doc) => {
    userIds.push(doc.id)
  })
  const periodIds = newselectedPeriods.value.map(period => period.id)

  if (userIds.length === 0) {
    console.log("Keine passenden User gefunden.")
    return
  }
  console.log("Get Service", periodIds)
  const servicesRef = collectionGroup(db, "service")
  const servicesQuery = query(servicesRef, where("wish.wishPeriodId", "in", periodIds))
  const servicesSnapshot = await getDocs(servicesQuery)

  servicesSnapshot.forEach((doc) => {
    const userPath = doc.ref.path.split("/")[1]; // userId extrahieren
//    console.log("UserPath", userPath, userIds)
    if (userIds.includes(userPath)) {
      const employservice = doc.data()
      let _serviceshift = getNormalizedService(employservice).split(',')[0]
      let _wishshift = employservice?.wish?.shift || 0
      let _vacation = employservice?.wish?.vacation || false
      console.log("Services-Wishes", _serviceshift, _wishshift, _vacation)
      switch (_wishshift.toString()) {
        case "1":
            earlyDaysMax.value++
            break
        case "2":
            middleDaysMax.value++
            break
        case "3":
            lateDaysMax.value++
            break
        case "4":
            nightExpressDaysMax.value++
            break
        case "5":
            sharedDaysMax.value++
            break
        case "10":
            freeDaysMax.value++
            break
        case "11":
            vacationDaysMax.value++
            break
        case "12":
            freeDaysMax.value++
            break
      }
      switch (_serviceshift) {
        case "1":
          if (_wishshift.toString() === _serviceshift)
            earlyDays.value++
          break
        case "2":
          if (_wishshift.toString() === _serviceshift)
            middleDays.value++
          break
        case "3":
          if (_wishshift.toString() === _serviceshift)
            lateDays.value++
          break
        case "4":
          if (_wishshift.toString() === _serviceshift)
            nightExpressDays.value++
          break
        case "5":
          if (_wishshift.toString() === _serviceshift)
            sharedDays.value++
          break
        case "10":
          if (_wishshift.toString() === _serviceshift)
            freeDays.value++
          break
        case "11":
          if (_vacation)
              vacationDays.value++
//          vacationDaysMax.value++
          break
        case "12":
          if (_vacation)
            freeDays.value++
//          freeDaysMax.value++
          break
        case "*":
          break
      }
      total.value = freeDays.value + earlyDays.value + middleDays.value + lateDays.value + 
          sharedDays.value + nightExpressDays.value + vacationDays.value
      totalMax.value = freeDaysMax.value + earlyDaysMax.value + middleDaysMax.value + lateDaysMax.value + 
          sharedDaysMax.value + nightExpressDaysMax.value + vacationDaysMax.value
    }
  })
}, {deep: true, immediate: true})
/*
const freeDays = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId) 
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.freeDays, 0));
});
const freeDaysMax = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  console.log("Statistiks", services.value)
  const filterStatistics = services.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );
  console.log("FilterStatistiks", filterStatistics)
  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.freeDaysMax, 0));
});

const earlyDays = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.earlyDays, 0));
});
const earlyDaysMax = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.earlyDaysMax, 0));
});

const middleDays = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.middleDays, 0));
});
const middleDaysMax = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.middleDaysMax, 0));
});

const lateDays = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.lateDays, 0));
});
const lateDaysMax = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.lateDaysMax, 0));
});

const sharedDays = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.sharedDays, 0));
});
const sharedDaysMax = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.sharedDaysMax, 0));
});

const nightExpressDays = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.nightExpressDays, 0));
});
const nightExpressDaysMax = computed(() => {
  const periodIds = selectedPeriods.value.map(period => period.id);
  const filterStatistics = statistics.value
      .filter(element =>
          selectedEmployCycles.value.includes(element.cycleId) &&
          periodIds.includes(element.wishPeriodId)
      );

  return Number(filterStatistics.reduce((partialSum, a) => partialSum + a.nightExpressDaysMax, 0));
});

const total = computed(() => {
return freeDays.value + earlyDays.value + middleDays.value + lateDays.value + sharedDays.value + nightExpressDays.value;
});

const totalMax = computed(() => {
  return freeDaysMax.value + earlyDaysMax.value + middleDaysMax.value + lateDaysMax.value + sharedDaysMax.value + nightExpressDaysMax.value;
});
*/
function generateCSV(){
  const header = ["Name", "Anzahl", "Maximal"];
  const rows = [
    ["Wunsch eingetragen", wdpInput.value, wdpInputMax.value],
//    ["Wunsch abgeschickt", wdpSend.value, wdpSendMax.value],
    ["Wunsch geöffnet", wdpOpened.value, wdpOpenedMax.value],
    ["Freie Tage", freeDays.value, freeDaysMax.value],
    ["Frühschicht", earlyDays.value, earlyDaysMax.value],
    ["Mittelschicht", middleDays.value, middleDaysMax.value],
    ["Spätschicht", lateDays.value, lateDaysMax.value],
    ["Geteilter Dienst", sharedDays.value, sharedDaysMax.value],
    ["Nachtexpress", nightExpressDays.value, nightExpressDaysMax.value],
    ["Gesamt", total.value, totalMax.value]
  ];
  
  const date = new Date();
  const formattedDate = date.toISOString().split("T")[0]; 
  exportToCSV(`WDP Statistik ${formattedDate}.csv`, header, ...rows);
}


function exportToCSV(filename, header, ...rows) {
  const csvContent = [
    header.join(","), 
    ...rows.map(row => row.join(",")) 
  ].join("\n");

  const bom = "\uFEFF"; // Byte Order Mark (BOM)
  const fullContent = bom + csvContent;
  
  const blob = new Blob([fullContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement("a");

  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);

  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}


</script>
<style scoped>

</style>